/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function updatePreorderNotice(show) {
    var notice = document.querySelector('[data-preorder-notice]');
    if (notice) notice.style.display = show ? '' : 'none';
  }

  // Seal Subscriptions' own widget only knows this product's (bundle-builder's) own
  // variants, so it can't be used for the P&M flavour picker, which points at variants
  // on 7 other products. pnm-flavour-picker.js hides Seal's widget and builds its own
  // Subscribe & Save toggle (defaulting to subscribe, same intent as this used to force)
  // for that flow instead - forcing Seal's own radio here would fight over the shared
  // selling_plan hidden field once that widget is hidden.


// Show only on Brand
  document.addEventListener('DOMContentLoaded', function() {
    function updateBrandDisplay(value) {
      const brand = value.toLowerCase().replace(/\s+/g, '-');
      // Hide all
      document.querySelectorAll('[class*="show-brand--"]').forEach(el => {
        el.classList.remove('show-brand--visible');
      });
      // Show matching
      const target = document.querySelectorAll(`.show-brand--${brand}`);
      target.forEach(el => {
        el.classList.add('show-brand--visible');
      });
    }

    document.querySelectorAll('input[name^="options[Flavour]"]').forEach(radio => {
      if (radio.hasAttribute('data-mixed-real')) return; // driven by fireRealRadio, not user clicks
      // On change
      radio.addEventListener('change', function() {
        if (this.checked) {
          updateBrandDisplay(this.value);
          updatePreorderNotice(this.value === 'Passionfruit' || this.value === 'Grapefruit');
        }
      });
      // On page load (default selected)
      if (radio.checked) {
        updateBrandDisplay(radio.value);
        updatePreorderNotice(radio.value === 'Passionfruit' || radio.value === 'Grapefruit');
      }
    });

    // Mixed pseudo-radio uses name="pseudo-mixed" to avoid the theme's availability checker,
    // so it must be wired into brand display separately
    const mixedPseudo = document.getElementById('mixed');
    if (mixedPseudo) {
      mixedPseudo.addEventListener('change', function() {
        if (this.checked) {
          updateBrandDisplay('mixed');
          updatePreorderNotice(false); // sub-dropdown handler re-shows it if Full Range is selected
        }
      });
      if (mixedPseudo.checked) updateBrandDisplay('mixed');
    }
  });


  // Star Rating Scroll Anchor
  document.addEventListener("DOMContentLoaded", function () {
    const ratings = document.querySelectorAll(".jdgm-rating");
    const carousel = document.querySelector(".jdgm-cards-carousel");

    if (!carousel) return;

    ratings.forEach(function(rating) {
      rating.addEventListener("click", function(e) {
        e.preventDefault();

        const offset = 120; // adjust for header height
        const elementPosition = carousel.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth"
        });
      });
    });
  });

  /* Video */
  document.querySelectorAll('.socialproof-media').forEach(slide => {
    slide.addEventListener('click', () => {
      const card = slide.closest('.socialproof-card');
      const video = slide.querySelector('video');

      if (!video) return;

      const isMuted = video.muted;

      // Reset all videos + states
      document.querySelectorAll('.socialproof-card').forEach(c => {
        c.classList.remove('is-playing');
      });

      document.querySelectorAll('.socialproof-media video').forEach(v => {
        v.muted = true;
      });

      // Toggle current
      if (isMuted) {
        video.muted = false;
        video.play();
        card.classList.add('is-playing');
      } else {
        video.muted = true;
        card.classList.remove('is-playing');
      }
    });
  });


// Mixed sub-dropdown
  document.addEventListener('DOMContentLoaded', function() {
    var mixedRadio = document.getElementById('mixed');
    var subDropdown = document.querySelector('[data-mixed-sub-dropdown]');

    if (!mixedRadio || !subDropdown) return;

    // Silently switch Pack Size to 12 Pack (no event dispatch — the Flavour change that
    // follows will cause the theme to re-read all :checked options including the new pack)
    function setSixPackVisibility(selectedMixVal) {
      var sixPack = document.querySelector('.product__selectors input[value="6 Pack"]');
      if (!sixPack) return;
      var sixPackBtn = sixPack.closest('.radio__button');
      if (selectedMixVal === 'Full Range') {
        sixPackBtn.style.display = 'none';
        if (sixPack.checked) {
          var twelvePack = document.querySelector('.product__selectors input[value="12 Pack"]');
          if (twelvePack) twelvePack.checked = true; // set only — no dispatch, Flavour change handles the update
        }
      } else {
        sixPackBtn.style.display = '';
      }
    }

    // Check the matching hidden real radio and fire its change so the theme updates the variant
    function fireRealRadio(val) {
      var target = null;
      subDropdown.querySelectorAll('input[data-mixed-real]').forEach(function(r) {
        r.checked = (r.value === val);
        if (r.value === val) target = r;
      });
      if (target) target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    mixedRadio.addEventListener('change', function() {
      subDropdown.removeAttribute('hidden');
      // Uncheck Lager / Pale Ale — not in the same radio group due to the pseudo-name
      document.querySelectorAll('input[name^="options[Flavour]"]').forEach(function(r) {
        if (!subDropdown.contains(r)) r.checked = false;
      });
      // Auto-select first visible sub-option if none chosen yet
      var checkedVisible = subDropdown.querySelector('input[name="pseudo-mixed-pack"]:checked');
      if (!checkedVisible) {
        checkedVisible = subDropdown.querySelector('input[name="pseudo-mixed-pack"]');
        if (checkedVisible) checkedVisible.checked = true;
      }
      if (checkedVisible) {
        setSixPackVisibility(checkedVisible.value);
        fireRealRadio(checkedVisible.value);
        updatePreorderNotice(checkedVisible.value === 'Full Range' || checkedVisible.value === 'Flavours' || checkedVisible.value === 'pick-n-mix');
      }
    });

    // Hide sub-dropdown when Lager / Pale Ale is selected
    document.querySelectorAll('input[name^="options[Flavour]"]').forEach(function(radio) {
      if (subDropdown.contains(radio)) return;
      radio.addEventListener('change', function() {
        subDropdown.setAttribute('hidden', '');
        mixedRadio.checked = false;
        setSixPackVisibility('');
        var pnmPanel = document.querySelector('[data-pnm-product]');
        if (pnmPanel) pnmPanel.setAttribute('hidden', '');
      });
    });

    // Visible sub-option radio clicked → update pack visibility then fire hidden real radio
    // pick-n-mix value is handled entirely by pick-n-mix.js
    subDropdown.querySelectorAll('input[name="pseudo-mixed-pack"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (this.value === 'pick-n-mix') {
          updatePreorderNotice(true);
          return;
        }
        setSixPackVisibility(this.value);
        fireRealRadio(this.value);
        updatePreorderNotice(this.value === 'Full Range' || this.value === 'Flavours');
      });
    });

    // Page load — apply pack visibility if a sub-option is already active
    var checkedOnLoad = subDropdown.querySelector('input[name="pseudo-mixed-pack"]:checked');
    if (checkedOnLoad) {
      setSixPackVisibility(checkedOnLoad.value);
      updatePreorderNotice(checkedOnLoad.value === 'Full Range' || checkedOnLoad.value === 'Flavours' || checkedOnLoad.value === 'pick-n-mix');
    }
  });

  // Default Pack Size to 12 Pack on fresh page load (no ?variant= URL param)
  document.addEventListener('DOMContentLoaded', function() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    var twelvePack = document.querySelector('.product__selectors input[value="12 Pack"]');
    if (twelvePack && !twelvePack.checked) {
      twelvePack.checked = true;
      twelvePack.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Pick n Mix — removing the bundle (or any of its hidden fulfilment cans) must remove every
  // other cart line sharing the same `_bundle_id`, otherwise the single cans are orphaned.
  // Implemented as its own capture-phase listener (rather than editing theme.js/theme.dev.js)
  // so it can't be dropped by the theme's build/minify step and can't affect non-PnM cart lines.
  (function() {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var bundlesInFlight = {};

    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-item-remove]');
      if (!button) return;

      var item = button.closest('[data-item]');
      var bundleId = item ? item.getAttribute('data-item-bundle-id') : null;
      if (!bundleId) return; // not a Pick n Mix line — let the theme handle removal as normal

      // Runs in the capture phase, ahead of the theme's own bubble-phase remove handler on
      // this button, so stopping it here fully replaces (rather than races) that handler.
      event.preventDefault();
      event.stopImmediatePropagation();

      if (bundlesInFlight[bundleId]) return;
      bundlesInFlight[bundleId] = true;

      var bundleItems = Array.from(document.querySelectorAll('[data-item-bundle-id="' + bundleId + '"]'));
      var updates = {};
      bundleItems.forEach(function(el) {
        var key = el.getAttribute('data-item');
        if (key) updates[key] = 0;
        el.classList.add('is-removed');
      });

      var cartEl = document.querySelector('cart-drawer') || document.querySelector('[data-cart-page]');
      if (cartEl) cartEl.classList.add('is-loading');

      fetch(cartRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
          .then(function(res) { return res.json(); })
          .then(function() {
            delete bundlesInFlight[bundleId];
            var cartItemsEl = document.querySelector('cart-items');
            if (cartItemsEl && typeof cartItemsEl.getCart === 'function') {
              cartItemsEl.getCart();
            } else {
              window.location.reload();
            }
          })
          .catch(function(err) {
            delete bundlesInFlight[bundleId];
            console.error('PnM bundle removal error', err);
            window.location.reload();
          });
    }, true);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
